/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import configureStore from "store";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
//import {loadStripe} from '@stripe/stripe-js';

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";

//const stripePromise = loadStripe('pk_test_51JmDEzEdkYBs3hebgPFH8tyVMXydOW5iBPbdINSzO7ztg7aRPbfT2wQ7t1hLqLrffWbT3OIq7aVQ9BdyC3miFbzC00sPusqvEw');

ReactDOM.render(
<Provider store={configureStore()}>
  <BrowserRouter>
    <Switch>
      <Route path="/admin" render={
          props => <AdminLayout {...props} />
      } />
      <Route path="/auth" render={
          props => <AuthLayout {...props} />
      } />
      <Redirect from="/" to="/admin/index" />
    </Switch>
  </BrowserRouter>
</Provider>,
  document.getElementById("root")
);
